// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"89e31bc8","396":"160cad14","669":"039d7de3","857":"ba4d5696","921":"b2f96548"}[chunkId] + ".chunk.js";
};